export default "__VITE_ASSET__DzCbQUjj__"